import { render, staticRenderFns } from "./BorcluForm.vue?vue&type=template&id=9df5959e"
import script from "./BorcluForm.vue?vue&type=script&lang=ts"
export * from "./BorcluForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports